export default __webpack_public_path__ + "static/media/cartridge-gg.b120c0e0.png";